import competitionService from '@jobseeker/common-core/services/competition.service';

import type {Dispatch} from 'react';
import type {AnyAction} from 'redux';

const getTimelines = async (
  dispatch: Dispatch<AnyAction>,
  competitionId: number
) => {
  const timelineInfo = await competitionService.fetchTimelineData(
    competitionId
  );
  if (
    timelineInfo?.registration &&
    Object.keys(timelineInfo?.registration).length > 0
  ) {
    dispatch({
      type: 'Competition/set_timeline_data',
      payload: {competition: timelineInfo},
    });
  }
};

export {getTimelines};
